/**
 * Which vote grades read as an upvote.
 *
 * A vote carries a grade string rather than a boolean, and three places in the
 * funnel decide "thumb up or thumb down" from it: the grid's Vote column, the
 * phone card that stands in for that row, and the share dialog's candidate
 * list. The set was written out twice before this existed; a fourth grade
 * added in one copy and not the others would show the same person up in one
 * reading and down in the next.
 */
export const UPVOTE_GRADES = new Set([
	"up",
	"5",
	"corona_certified",
	"4",
	"invite",
	"inmail",
]);

export const isUpvoteGrade = (grade: string): boolean => UPVOTE_GRADES.has(grade);
